import React, { useContext, useEffect, useState } from 'react';

import { Divider, Input, Modal, Select } from 'antd';

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import EPatientsDestinies from '../../enums/EPatientsDestinies';
import api from '../../services/api';
import { displayMessage } from '../../services/helper';

const patients_initial = []

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function AddPatient(props) {

    const { windowHeight } = useContext(GeneralContext)

    const [patients_filtered, setPatientsFiltered] = useState(patients_initial)
    const [patientDestiny, setPatientDestiny] = useState(null)
    const [selectedMonitor, setSelectedMonitor] = useState(null)
    const [monitorsAvailable, setMonitorsAvailable] = useState([])

    useEffect(()=>{
        getAvailableMonitors()
    },[])


    const getAvailableMonitors = async()=>{
        const {data} = await api.monitor.list()
        const monitorsoptions = data.map(e=> ({label: e?.full_name, value: e?.id}))
        setMonitorsAvailable(monitorsoptions)
    }
    const cardPatient = patient => {
        return (
            <div 
                title={`${patient.first_name} ${patient.last_name}`} 
                onClick={() => handleSelectPatientToAdd(patient)} 
                className='flex flex-col' 
                style={{ fontSize: 10, cursor: 'pointer', border: '1px solid #1b3663', width: 130, heigh: 100, cursor: 'pointer' }}
            >
                <div className='flex flex-col' style={{ background: '#1b3663', color: 'white', fontWeight: 'bold', textAlign: 'center', height: 70, maxHeight: 70 }}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{`${patient.first_name} ${patient.last_name}`}</div>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{`${patient.identificator_patient && patient.identificator_patient != "null" ? patient.identificator_patient : displayMessage('NOT_INFORMED')}`}</div>
                </div>
                <div style={{ width: 128, height: 100, background: 'lightblue', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' }} src={patient.image_url} />
                </div>
            </div>
        )
    }

    const handleSelectPatientToAdd = (patient) => {
        if (patientDestiny == EPatientsDestinies.MONITORY_ROOM.value) {
            props.handleAddPatient(patient)
        }
        else if (patientDestiny == EPatientsDestinies.EXERCISE_ROOM.value) {
            const monitor_id = selectedMonitor
            const in_exercise = true
            props.handleAddPatient(patient, monitor_id, in_exercise)
        }
    }

    const loadPatientsFilter = (find, notInMonitory) => {
        api.patient.list({ find, notInMonitory, limit_to_x_registers: 10 }).then(
            rs => {
                setPatientsFiltered(rs.data)
            }
        )
    }

    let debounceTimer;

    const debouncedLoadPatientsFilter = (find, notInMonitory) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            loadPatientsFilter(find, notInMonitory);
        }, 1000)
    }

    const handleInputChange = e => {
        const value = e.target.value;
        if (value?.length >= 3) {
            const by_not_active = true;
            debouncedLoadPatientsFilter(value, by_not_active);
        } else {
            setPatientsFiltered([]);
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('ADD_PATIENT')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <div className='flex flex-col'>
                <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center',flexWrap: 'wrap', gap: 10 }}>
                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}>
                        {displayMessage('SELECT_PATIENT_DESTINY')}               
                    </div>
                    <Select
                        className='flex flex-1 min-w-[160px]'
                        options={Object.values(EPatientsDestinies)}
                        placeholder={'...'}
                        value={patientDestiny}
                        onChange={(e)=>setPatientDestiny(e)}
                    />
                </div>
                {
                    patientDestiny == EPatientsDestinies.EXERCISE_ROOM.value &&
                    <div className='flex flex-col'>
                        <Divider />
                        <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center',flexWrap: 'wrap', gap: 10 }}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663' }}>
                                {displayMessage('SELECT_MONITOR_FOR_PATIENT')}               
                            </div>
                            <Select
                                className='flex flex-1 min-w-[160px]'
                                options={monitorsAvailable}
                                placeholder={'...'}
                                value={selectedMonitor}
                                onChange={(e)=>setSelectedMonitor(e)}
                            />
                        </div>
                    </div>
                }
                {
                    (patientDestiny == EPatientsDestinies.MONITORY_ROOM.value || 
                    (patientDestiny == EPatientsDestinies.EXERCISE_ROOM.value && selectedMonitor)) &&
                    <div className='flex flex-col'>
                         <Divider />
                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, marginBottom: 16 }}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663', }}> {displayMessage('SMART_SEARCH_PATIENT_BUTTON')}</div>
                            <div style={{ color: '#1b3663', marginTop: 4, marginBottom: 8 }}> {displayMessage('SMART_SEARCH_PATIENT_BUTTON_1')} <strong>{displayMessage('NAME')}</strong> {displayMessage('SMART_SEARCH_PATIENT_BUTTON_2')}, <strong>identificador</strong> do paciente, <strong>cpf</strong> do paciente ou do responsável e <strong>email</strong> do paciente:</div>
                            <Input
                                type="text"
                                size='large'
                                placeholder={displayMessage('SMART_SEARCH_PATIENT_BUTTON_PLACEHOLDER')}
                                onChange={handleInputChange}
                                className={inputsClassName}
                            />
                        </div>
                    </div>
                }

                <div className='flex flex-row' style={{ flexWrap: 'wrap', gap: 5 }}>
                    {
                        patients_filtered.filter(p_f => p_f?.first_name?.toLowerCase()).map(
                            p => cardPatient(p)
                        )
                    }
                </div>
            </div>

        </Modal >
    )
}